import path from "../../../../packages/fnacdarty-svg-ref-loader/svg-id.js?id=$!./icon_i_055_arrow_right_01.svg"; export default path + "#$"